<template>
  <v-dialog
    :value="isOpen"
    persistent
    max-width="450"
    content-class="remove-images-dialog">
    <v-card>
      <dialog-header text="Delete Images" @closeModal="cancelDeleteImages" />
      <v-card-text class="pa-5">
        You have selected {{this.proofsheetImagesToDelete.length}} images to delete. Click "Confirm" to delete these images.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="deleteImages" class="modal-cta">Confirm</v-btn>
        <v-btn text @click="cancelDeleteImages" class="modal-cta">Cancel</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogHeader from "../dialogs/DialogHeader";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "removeImagesDialog",
  components: {
    dialogHeader
  },
  computed: {
    ...mapGetters(["proofsheetImagesToDelete"]),
    isOpen(){
      return this.proofsheetImagesToDelete && this.proofsheetImagesToDelete.length;
    }
  },
  methods: {
    ...mapActions(["deleteImages"]),
    ...mapMutations(["cancelDeleteImages"])
  }
}
</script>